module.exports = __webpack_public_path__ + "img/arrow-down.af763cab.svg";